import React from "react";
import { Grid, IconButton, withStyles } from "@material-ui/core";
import {DeleteOutlined} from "@material-ui/icons"

const styles = (theme) => ({
  iconButtonRoot: {
    color: theme.errorTextColor,
    float: "right",
    display: "flex",
  },
});

const DeleteTrailer = (props) => {
  return (
    <Grid item xs={12}>
      <IconButton
        classes={{
          root: props.classes.iconButtonRoot,
        }}
        onClick={() => props.onClick(props.id)}
      >
        <DeleteOutlined />
      </IconButton>
    </Grid>
  );
};

export default withStyles(styles)(DeleteTrailer);
